import React, { lazy, Suspense, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Star, UserPlus } from "lucide-react";
import { normalizePathname } from "../../utils/publicRouteMode";
import { loadPreSignupModal } from "../PreSignupModal/preloadPreSignupModal";
import "./PublicFooter.css";

const PreSignupModal = lazy(loadPreSignupModal);

const MOBILE_FOOTER_LINKS = [
  { id: "signup", label: "Cadastre-se", Icon: UserPlus },
  { id: "models", to: "/acompanhantes-virtuais/", label: "Modelos", Icon: Star },
];

function isLinkActive(pathname, target) {
  const normalizedPath = normalizePathname(pathname);
  const normalizedTarget = normalizePathname(target);

  if (normalizedTarget === "/") {
    return normalizedPath === "/";
  }

  return (
    normalizedPath === normalizedTarget ||
    normalizedPath.startsWith(`${normalizedTarget}/`)
  );
}

export default function PublicFooter() {
  const location = useLocation();
  const [isPreSignupOpen, setIsPreSignupOpen] = useState(false);
  const openSignup = () => {
    loadPreSignupModal();
    setIsPreSignupOpen(true);
  };

  return (
    <>
      <footer className="public-footer" aria-label="Rodapé público">
        <div className="public-footer__inner">
          <nav className="public-footer__mobile-links" aria-label="Atalhos públicos essenciais">
            {MOBILE_FOOTER_LINKS.map((item) => {
              if (item.id === "signup") {
                return (
                  <button
                    key="mobile-signup"
                    type="button"
                    className="public-footer__mobile-link"
                    onPointerEnter={loadPreSignupModal}
                    onFocus={loadPreSignupModal}
                    onClick={openSignup}
                  >
                    <span className="public-footer__mobile-icon" aria-hidden="true">
                      <item.Icon size={18} />
                    </span>
                    <span className="public-footer__mobile-text">{item.label}</span>
                  </button>
                );
              }

              const active = isLinkActive(location.pathname, item.to);
              return (
                <Link
                  key={`mobile-${item.to}`}
                  className={`public-footer__mobile-link${active ? " is-active" : ""}`}
                  to={item.to}
                  aria-current={active ? "page" : undefined}
                >
                  <span className="public-footer__mobile-icon" aria-hidden="true">
                    <item.Icon size={18} />
                  </span>
                  <span className="public-footer__mobile-text">{item.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>
      </footer>

      {isPreSignupOpen && (
        <Suspense fallback={null}>
          <PreSignupModal isOpen={isPreSignupOpen} onClose={() => setIsPreSignupOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
